/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_PRODUCTS, GET_PRODUCTS, SET_PRODUCTS } from 'src/actions/productActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PRODUCTS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_PRODUCTS: {
      const { products, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = products;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    case SET_PRODUCTS: {
      const { products } = action.payload;

      return produce(state, (draft) => {
        draft.items = products;
      });
    }

    default: {
      return state;
    }
  }
};

export default productReducer;
